import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class Menu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.menuRef = React.createRef();
  }

  componentDidMount() {
    if (!this.props.noOffClickClose) {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    if (!this.props.noOffClickClose) {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }

  toggle = () => {
    this.setState(
      ({ isOpen }) => ({
        isOpen: !isOpen,
      }),
      () => {
        this.props.onToggle(this.state.isOpen);
      }
    );
  };

  close = () => {
    this.setState(
      {
        isOpen: false,
      },
      this.props.onToggle(false)
    );
  };

  handleClickOutside = (e) => {
    if (!this.menuRef.current.contains(e.target) && this.state.isOpen) {
      this.close();
    }
  };

  render() {
    const { isOpen } = this.state;
    return this.props.children({
      isOpen,
      toggle: this.toggle,
      menuRef: this.menuRef,
      close: this.close,
      ...this.props,
    });
  }
}

Menu.propTypes = {
  onToggle: PropTypes.func,
};

Menu.defaultProps = {
  onToggle: () => {},
};

export default Menu;
